import { Link } from 'react-router-dom';
import { getPublicImgUrl } from '../utils/common';

export default function Footer() {
    const now = new Date();
    const currentYear = now.getFullYear();
    return (
        <>
            <div className="container-fluid footer py-5 wow fadeIn" data-wow-delay="0.2s">
                <div className="container">
                    <div className="row g-5">
                        <div className="col-md-6 col-lg-6 col-xl-3">
                            <div className="footer-item d-flex flex-column">
                                <img className="text-white mb-3" src={getPublicImgUrl()+"/VAROSA.png"} width={114} height={78} alt="Logo" />
                                <p>VAROSA HEALTH TECHNOLOGIES PRIVATE LIMITED <br />CIN: U86900WB2025PTC278863</p>
                                <div className="d-flex align-items-center">
                                    <i className="fas fa-share fa-2x text-white me-2"></i>
                                    <a href="https://play.google.com/store/apps/details?id=com.varosa.patient" className="btn-square btn btn-primary text-white rounded-circle mx-1" target="_blank" rel="noopener noreferrer"><i className="fab fa-google-play"></i></a>
                                    {/* <a className="btn-square btn btn-primary text-white rounded-circle mx-1" href=""><i className="fab fa-facebook-f"></i></a>
                                    <a className="btn-square btn btn-primary text-white rounded-circle mx-1" href=""><i className="fab fa-twitter"></i></a>
                                    <a className="btn-square btn btn-primary text-white rounded-circle mx-1" href=""><i className="fab fa-instagram"></i></a>
                                    <a className="btn-square btn btn-primary text-white rounded-circle mx-1" href=""><i className="fab fa-linkedin-in"></i></a> */}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xl-3">
                            <div className="footer-item d-flex flex-column">
                                <h4 className="mb-4 text-white">Quick Links</h4>
                                <Link to="/aboutus"><i className="fas fa-angle-right me-2"></i> About Us</Link>
                                <Link to="/contactus"><i className="fas fa-angle-right me-2"></i> Contact Us</Link>
                                <Link to="/privacypolicy"><i className="fas fa-angle-right me-2"></i> Privacy Policy</Link>
                                <Link to="/termsandconditions"><i className="fas fa-angle-right me-2"></i> Terms & Conditions</Link>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xl-3">
                            <div className="footer-item d-flex flex-column">
                                <h4 className="mb-4 text-white"> Services</h4>
                                <a href="#"><i className="fas fa-angle-right me-2"></i> Period doubts or Pregnancy</a>
                                <a href="#"><i className="fas fa-angle-right me-2"></i> Acne, pimple or skin issues</a>
                                <a href="#"><i className="fas fa-angle-right me-2"></i> Cold, cough or fever issues</a>
                                <a href="#"><i className="fas fa-angle-right me-2"></i> Depression or anxiety issues</a>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xl-3">
                            <div className="footer-item d-flex flex-column">
                                <h4 className="mb-4 text-white">Contact Info</h4>
                                <a href="#"><i className="fa fa-map-marker-alt me-2"></i> 63, A.C. ROAD, (LANE-10), P.O. KHAGRA, BERHAMPORE, KHAGRA, MURSHIDABAD, BERHAMPORE, WEST BENGAL - 742103</a>
                                <a href="mailto:varosahealth@gmail.com"><i className="fas fa-envelope me-2"></i> varosahealth@gmail.com</a>
                                <a href="tel:+91 8240112175"><i className="fas fa-phone me-2"></i> +91 8240112175</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-fluid copyright py-4">
                <div className="container">
                    <div className="row g-4 align-items-center">
                        <div className="col-md-6 text-center text-md-start mb-md-0">
                            <span className="text-white"><i className="fas fa-copyright text-light me-2"></i> {currentYear} <Link to="/">Varosa</Link>, All right reserved.</span>
                        </div>
                        <div className="col-md-6 text-center text-md-end text-white">
                            Designed By <a className="border-bottom" href="https://www.webworldtech.in/">WEB WORLD TECH</a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}